import React from 'react';
import './EventDetails.css';

import { 
  FaDollarSign, 
  FaTrophy, 
  FaClock, 
  FaClipboardCheck,
  FaFire,
  FaMoneyBillWave,
  FaCalendarAlt,
  FaUtensils,
  FaCheckCircle,
  FaInfoCircle,
  FaLightbulb,
  FaWater,
  FaBolt,
  FaMapMarkerAlt,
  FaBaby,
  FaGraduationCap,
  FaCookie,
  FaLeaf,
  FaBreadSlice,
  FaHeart
} from 'react-icons/fa';

import { GiBarbecue, GiChickenOven, GiMeat } from 'react-icons/gi';

const EventDetails = () => {
  return (
    <div className="details-container">
      <div className="hero-section">
        <div className="hero-background-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
        </div>
        <div className="hero-content">
          <h1><FaClipboardCheck className="hero-icon" />Event Details</h1>
          <p className="hero-subtitle">Everything you need to know about the Segovia BBQ Cookoff</p>
        </div>
      </div>

      <div className="info-card">
        <FaDollarSign className="card-icon" />
        <div className="card-content">
          <h2>Entry Fees & Categories</h2>
          <div className="fees-grid">
            <div className="fee-item">
              <GiBarbecue className="fee-icon" />
              <div className="fee-info">
                <span className="fee-category">BBQ Team (CBA)</span>
                <span className="fee-amount">$200</span>
                <span className="fee-description">Chicken, Ribs, Brisket</span>
              </div>
            </div>
            <div className="fee-item">
              <FaUtensils className="fee-icon" />
              <div className="fee-info">
                <span className="fee-category">Jackpot Categories</span>
                <span className="fee-amount">$25 each</span>
                <span className="fee-description">Beans, Fajita, Pan de Campo</span>
              </div>
            </div>
            <div className="fee-item">
              <FaFire className="fee-icon" />
              <div className="fee-info">
                <span className="fee-category">Kids BBQ Cookoff</span>
                <span className="fee-amount">$25</span>
                <span className="fee-description">Ages 5-17</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="info-card prize-card">
        <FaTrophy className="card-icon" />
        <div className="card-content">
          <h2>$5,000 Prize Pool + $1,000 Charity Donation</h2>
          <p className="prize-description">CBA sanctioned event with individual category payouts plus community giving</p>
          
          <div className="prize-section">
            <h3><FaMoneyBillWave className="section-icon" />Overall Awards</h3>
            <div className="prize-grid">
              <div className="prize-item grand">
                <span className="prize-amount">$500</span>
                <span className="prize-title">Grand Champion</span>
              </div>
              <div className="prize-item reserve">
                <span className="prize-amount">$300</span>
                <span className="prize-title">Reserve Grand Champion</span>
              </div>
            </div>
            <p className="prize-total">Subtotal: <span className="amount">$800</span></p>
          </div>
          
          <div className="prize-section">
            <h3><GiBarbecue className="section-icon" />CBA Category Payouts</h3>
            <p className="prize-description">Each category (Brisket, Ribs, Chicken) pays out top 10 places:</p>
            <div className="cba-prizes">
              <div className="cba-prize">1st Place: <span className="amount">$400</span></div>
              <div className="cba-prize">2nd Place: <span className="amount">$300</span></div>
              <div className="cba-prize">3rd Place: <span className="amount">$200</span></div>
              <div className="cba-prize">4th Place: <span className="amount">$150</span></div>
              <div className="cba-prize">5th Place: <span className="amount">$100</span></div>
              <div className="cba-prize">6th-10th Place: <span className="amount">$50 each</span></div>
            </div>
            <p className="prize-total">Per Category: <span className="amount">$1,400</span> | Total for 3 Categories: <span className="amount">$4,200</span></p>
          </div>
          
          <div className="prize-section">
            <h3><FaGraduationCap className="section-icon" />High School Brisket Division</h3>
            <p className="prize-description">Prize pool based on number of participants - the more kids that sign up, the bigger the prizes!</p>
          </div>

          <div className="prize-section">
            <h3><FaBaby className="section-icon" />Kids BBQ Division (Junior & Senior)</h3>
            <p className="prize-description">Prize pool based on number of participants - the more kids that sign up, the bigger the prizes!</p>
          </div>

          <div className="prize-section community-section">
            <h3><FaHeart className="section-icon" />Charity Donation</h3>
            <p className="prize-description"><strong>$1,000 donated to local charity</strong> - Supporting our community while celebrating BBQ!</p>
            <div style={{marginTop: '1.5rem', padding: '1rem', background: 'rgba(201, 61, 53, 0.1)', borderRadius: '10px', borderLeft: '4px solid var(--primary-color)'}}>
              <p style={{margin: 0, fontWeight: 600, color: 'var(--primary-color)'}}>Total Event Value: $6,000+ ($5,000 prizes + $1,000 charity + kids pool)</p>
            </div>
          </div>
          
          <div className="prize-section">
            <h3><FaUtensils className="section-icon" />Jackpot Category Payouts</h3>
            <p className="prize-description">50% of the entry pot is paid out per category to the top 3 spots (60/30/10 split).</p>
          </div>
        </div>
      </div>

      <div className="info-card">
        <FaClock className="card-icon" />
        <div className="card-content">
          <h2>Schedule & Turn-In Times</h2>
          <div className="schedule-grid">
            <div className="schedule-item">
              <FaCalendarAlt className="schedule-icon" />
              <div className="schedule-info">
                <span className="schedule-label">Setup</span>
                <span className="schedule-time">Friday, October 24, 2025</span>
              </div>
            </div>
            <div className="schedule-item">
              <FaCalendarAlt className="schedule-icon" />
              <div className="schedule-info">
                <span className="schedule-label">Cookoff</span>
                <span className="schedule-time">Saturday, October 25, 2025</span>
              </div>
            </div>
          </div>
          
          <div className="turnin-section">
            <h3><GiBarbecue className="section-icon" />Turn-In Schedule</h3>
            <div className="turnin-grid">
              <div className="turnin-item">
                <GiChickenOven className="turnin-icon" />
                <span className="turnin-category">Chicken</span>
                <span className="turnin-time">11:30 AM</span>
              </div>
              <div className="turnin-item">
                <GiMeat className="turnin-icon" />
                <span className="turnin-category">Ribs</span>
                <span className="turnin-time">12:45 PM</span>
              </div>
              <div className="turnin-item">
                <FaCookie className="turnin-icon" />
                <span className="turnin-category">Dessert (Jackpot)</span>
                <span className="turnin-time">1:30 PM</span>
              </div>
              <div className="turnin-item">
                <GiMeat className="turnin-icon" />
                <span className="turnin-category">Brisket</span>
                <span className="turnin-time">2:15 PM</span>
              </div>
              <div className="turnin-item">
                <FaGraduationCap className="turnin-icon" />
                <span className="turnin-category">High School Brisket</span>
                <span className="turnin-time">2:45 PM</span>
              </div>
              <div className="turnin-item">
                <FaLeaf className="turnin-icon" />
                <span className="turnin-category">Beans (Jackpot)</span>
                <span className="turnin-time">3:15 PM</span>
              </div>
              <div className="turnin-item">
                <GiMeat className="turnin-icon" />
                <span className="turnin-category">Fajita (Jackpot)</span>
                <span className="turnin-time">3:45 PM</span>
              </div>
              <div className="turnin-item">
                <FaBreadSlice className="turnin-icon" />
                <span className="turnin-category">Pan de Campo (Jackpot)</span>
                <span className="turnin-time">4:15 PM</span>
              </div>
              <div className="turnin-item">
                <FaBaby className="turnin-icon" />
                <span className="turnin-category">Kids BBQ (Pork Chops)</span>
                <span className="turnin-time">4:30 PM</span>
              </div>
              <div className="turnin-item awards-ceremony">
                <FaTrophy className="turnin-icon" />
                <span className="turnin-category">🏆 Awards Ceremony</span>
                <span className="turnin-time">5:00 PM</span>
              </div>
            </div>
            <p className="turnin-note">
              <FaInfoCircle className="note-icon" />
              All turn-in times are strictly enforced. Late entries will be disqualified.
            </p>
          </div>
        </div>
      </div>
      
      <div className="info-card">
        <FaLightbulb className="card-icon" />
        <div className="card-content">
          <h2>Rules & Amenities</h2>
          <div className="rules-grid">
            <div className="rule-item">
              <FaCheckCircle className="rule-icon" />
              <span>Random meat inspection is required at check-in.</span>
            </div>
            <div className="rule-item">
              <FaWater className="rule-icon" />
              <span>Water is available on-site.</span>
            </div>
            <div className="rule-item">
              <FaBolt className="rule-icon" />
              <span>Electricity is limited; generators are encouraged.</span>
            </div>
            <div className="rule-item">
              <FaMapMarkerAlt className="rule-icon" />
              <span>Team spaces are first come, first served. Call to reserve your spot!</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventDetails; 